import { render } from "./WorkExpComponent.vue?vue&type=template&id=1c676946"
import script from "./WorkExpComponent.vue?vue&type=script&lang=js"
export * from "./WorkExpComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__